import React, { useEffect } from "react";

import { AstridDaoStoreState, Decimal18 } from "@astrid-dao/lib-base";
import { Button } from "theme-ui";

import { useAstridDaoSelector } from "../../hooks/useAstridDaoSelector";
import { Transaction, useMyTransactionState } from "../Transaction";
import { useConvertWastrView } from "./context/ConvertWastrViewContext";

const selector = ({ wrappedTokenAllowance }: AstridDaoStoreState) => ({
  hasApprovedTransactions: !wrappedTokenAllowance.isZero
});

const TRANSACTION_ID = "convert-wastr-approve";

export const Approve: React.FC = () => {
  const { dispatch, approveWastr } = useConvertWastrView();

  const { hasApprovedTransactions } = useAstridDaoSelector(selector);
  const transactionState = useMyTransactionState(TRANSACTION_ID);

  useEffect(() => {
    if (transactionState.type === "confirmedOneShot") {
      dispatch({ type: "startDepositing" });
    }
  }, [transactionState.type, dispatch]);

  if (hasApprovedTransactions) {
    return null;
  }

  return (
    <Transaction
      id={TRANSACTION_ID}
      send={_ => {
        return approveWastr(Decimal18.INFINITY);
      }}
      showFailure="asTooltip"
      tooltipPlacement="bottom"
    >
      <Button>Approve</Button>
    </Transaction>
  );
};
